// src/registry/initializer.js
import { componentRegistry } from './ComponentRegistry';

// Import client-specific components
import MemberNotes from '../components/MemberNotes/Loadable';
import ArcMemberNotes from '../clients/arc/components/MemberNotes/Loadable';
import MemberTags from '../components/EventMemberTags/Loadable';
import ArcMemberTags from '../clients/arc/components/MemberTags/Loadable';

// Client-specific components that need direct imports

// Import default components
// Note: Update these imports to match your actual component locations

/**
 * Initialize the component registry with all default and client-specific components
 * This function should be called during application initialization
 */
export function initializeRegistry() {
  try {
    // Register client-specific components based on configuration
    const clientConfig = getClientConfig();
    const clientId = clientConfig.clientId || 'default';

    switch (clientId) {
      case 'arc':
        registerClientArcComponents();
        break;
      default:
        registerDefaultComponents();
    }

    console.warn(`Component registry initialized for client: ${clientId}`);

    return true;
  } catch (error) {
    console.error('Failed to initialize component registry:', error);
    return false;
  }
}

/**
 * Register all default component implementations
 */
function registerDefaultComponents() {
  try {
    // Register default components
    componentRegistry.register('MemberNote:default', MemberNotes);
    componentRegistry.register('MemberTags:default', MemberTags);

    // Add more default components as needed
  } catch (error) {
    console.error('Error registering default components:', error);
  }
}

/**
 * Register ARC specific components
 */
function registerClientArcComponents() {
  try {
    // Example: ARC wants to use TeamNotes instead of MemberNotes
    componentRegistry.register('MemberNote:default', ArcMemberNotes);
    componentRegistry.register('MemberTags:default', ArcMemberTags);
    // Register all exported components from ARC
    // Object.entries(arcComponents).forEach(([name, component]) => {
    //   if (name !== 'default') {
    //     componentRegistry.register('arc', name, component);
    //   }
    // });
  } catch (error) {
    console.error('Error registering ARC components:', error);
  }
}

/**
 * Get client configuration from environment or store
 * @returns {Object} - Client configuration object
 */
function getClientConfig() {
  // In a real application, this could come from:
  // 1. Redux store
  // 2. Environment variables
  // 3. API call
  // 4. Local storage

  // For now, we'll use a simple environment variable approach
  return {
    clientId: process.env.CLIENT || 'default',
    components: {},
  };
}

/**
 * Check if a component is registered for a specific client
 * @param {string} componentKey - Component identifier
 * @param {string} clientId - Client identifier
 * @returns {boolean} - True if component is registered
 */
export function isComponentRegistered(componentKey) {
  return componentRegistry.has(componentKey);
}
